import React from 'react';
import '../styles/metric.css';
import { translate } from 'react-polyglot';
import Donut from './Donut';

const CustomerHappinessMetric = ({ customer_satisfaction, t }) =>
  <div>
    <Donut
      value={customer_satisfaction / 100}
      className="metric metric--customer-happiness"
    >
      {t('quality_satisfaction')}
    </Donut>
    <div className="metric__global">
      {t('quality_benchmark', { VALUE: '86%' })}
    </div>
  </div>;

export default translate()(CustomerHappinessMetric);



// WEBPACK FOOTER //
// ./src/components/CustomerHappinessMetric.js